import { useCallback } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { addTextState } from '../states/addTextState';
import { inputTextState } from '../states/inputTextState';

import classes from './InputBlock.module.scss';

const getKey = () => Math.random().toString(32).substring(2); // 0〜1未満の乱数字を取得して、数字を32進法に文字列に変換。前から３番目から文字を抽出

export const InputBlock = () => {
  const inputText = useRecoilValue(inputTextState);
  const setInputText = useSetRecoilState(inputTextState);
  const addText = useRecoilValue(addTextState);
  const setAddText = useSetRecoilState(addTextState);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputText(event.target.value);
    },
    [setInputText]
  );
  const onClick = () => {
    setAddText([...addText, { id: getKey(), text: inputText }]);
    setInputText('');
  };

  return (
    <div className={classes.block}>
      <input type="text" value={inputText} onChange={onChange} className={classes.input} />
      <button type="button" className={classes.button} onClick={onClick}>
        登録
      </button>
    </div>
  );
};
